import React, { PureComponent } from 'react';
import { InputNumber as InputNumberAnt } from 'antd';
import PropTypes from 'prop-types';

export default class InputNumber extends PureComponent {
  render() {
    return (
      <InputNumberAnt
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.props}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
      />
    );
  }
}

InputNumber.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

InputNumber.defaultProps = {
  type: ''
};
